













import { defineComponent } from "@vue/composition-api";

export type ItemOption = {
  title: string;
  value: string | number;
};

/**
 * 导航切换
 */
export default defineComponent({
  props: {
    items: {
      type: Array as () => ItemOption[],
    },
    value: {
      type: [Number, String],
    },
  },
  setup(props, { emit }) {
    const handleClick = (value: string | number) => {
      emit("input", value);
    };

    return { handleClick };
  },
});
